import Layout from "@/admin/js/layout/index.vue";

const saasQueueRoutes = {
    name: 'saas-queue',
    path: '/saas-queue',
    component: Layout,
    meta: { title: 'SaaS очередь', noCache: false, },
    redirect: '/saas-queue/list',
    children: [
        {
            name: 'saas-queue-list',
            path: 'list',
            component: () => import('@/admin/js/views/saas-queue/index.vue'),
            meta: { title: ''}
        }
    ]
};

export default saasQueueRoutes;